var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{large : _vm.large},attrs:{"role":"complementary"}},[_c('div',{staticClass:"image col-xs-2"},[_vm._t("image")],2),_c('div',{staticClass:"content col-xs-10"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }